export const SITE_URL = 'https://galiastandardpoodles.com';
export const SITE_NAME = 'Galia Standard Poodles';
/** First Calcifer carousel photo — used for homepage and default link previews. */
export const CALCIFER_HERO_IMAGE = '/CalciferChampion.jpg';
export const DEFAULT_OG_IMAGE = `${SITE_URL}${CALCIFER_HERO_IMAGE}`;

export const pagePathToUrl = (path: string): string => {
    if (path === '/') {
        return `${SITE_URL}/`;
    }
    return `${SITE_URL}${path}`;
};

export const toAbsoluteImageUrl = (imagePath: string): string => {
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }
    const normalized = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
    return `${SITE_URL}${normalized}`;
};
